export default [
    {
      path: '/b/berita-acara-hasil-inventarisasi',
      redirect: '/b/berita-acara-hasil-inventarisasi',
      name: 'bBeritaAcaraHasilInventarisasi',
      component: () => import('@/views/NestedRoute.vue'),
      children: [
        {
          path: '',
          name: 'bBeritaAcaraHasilInventarisasiIndex',
          component: () => import('@/views/b/beritaAcaraHasilInventarisasi/Index.vue'),
          meta: {
            action: 'Lihat',
            resource: 'b-berita-acara-hasil-inventarisasi',
            pageTitle: 'Berita Acara Hasil Inventarisasi',
            breadcrumb: [
              {
                text: 'B',
              },
              {
                text: 'Berita Acara Hasil Inventarisasi',
                active: true,
              },
            ],
          },
        },
      ],
    },
  ]
  